import React from 'react';
import PropTypes from 'prop-types';
import { Container, Text, Button, Flex } from '@chakra-ui/react';
import SimpleSlider from '@repo/ui-components/dept/molecules/SimpleSlider';
import { generateSectionId } from '@repo/ui-components/dept/utils/generateSectionId';
import Link from '@repo/ui-components/tailwind/Link';
import CarouselRowBlogTopicsItem from './CarouselRowBlogTopicsItem';

function CarouselRowBlogTopics({ block }) {
  return (
    <Container {...generateSectionId(block)} py={14}>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        mb={{ base: 6, md: 14 }}
      >
        <Flex flexDir="column">
          <Text textStyle="h2" as="h2" fontWeight="bold" mb={2}>
            {block.title}
          </Text>
          <Text maxW={{ base: 'full', md: '32.5rem' }}>
            {block.description}
          </Text>
        </Flex>

        {block.cta && (
          <Button
            as={Link}
            link={block?.cta?.link}
            display={['none', null, 'inline-flex']}
            variant="primary"
            alignSelf="end"
          >
            {block.cta?.text}
          </Button>
        )}
      </Flex>
      <SimpleSlider
        items={block.categories}
        sliderItem={CarouselRowBlogTopicsItem}
      />
      {block.cta && (
        <Button
          as={Link}
          link={block?.cta?.link}
          display={['inline-flex', null, 'none']}
          width="100%"
          mt={6}
          variant="primary"
        >
          {block.cta?.text}
        </Button>
      )}
    </Container>
  );
}

CarouselRowBlogTopics.propTypes = {
  block: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    cta: PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.shape({
        linkType: PropTypes.string,
        href: PropTypes.string,
        internalLink: PropTypes.shape({
          slug: PropTypes.shape({
            current: PropTypes.string,
          }),
        }),
      }),
    }).isRequired,
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        _key: PropTypes.string.isRequired,
        cta: PropTypes.shape({
          linkType: PropTypes.string,
        }),
        categoryReference: PropTypes.shape({
          title: PropTypes.string.isRequired,
          description: PropTypes.string,
          image: PropTypes.shape({
            asset: PropTypes.shape({
              url: PropTypes.string,
            }),
            alt: PropTypes.string,
          }),
        }),
        media: PropTypes.shape({
          image: PropTypes.shape({
            asset: PropTypes.shape({
              url: PropTypes.string,
            }),
            alt: PropTypes.string,
          }),
        }),
        description: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
};

export default CarouselRowBlogTopics;
